import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import * as echarts from 'echarts';
import { formatThousandth } from '../../../../utils/common';
import { DealerPortalService } from 'src/app/services/dealerPortal.service';
import { Router } from '@angular/router';
import { CustomerService } from 'src/app/services/customer.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { LoginService } from 'src/app/services/login.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'target-achievement',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.less']
})
export class DealerTargetAchievementComponent implements OnInit, OnDestroy, OnChanges {
  @Input() data!: any;
  private customerSubscription: Subscription | undefined;
  constructor(
     private dealerPortalService: DealerPortalService,
     private router:Router,
     private customerService: CustomerService,
     private loginService: LoginService,
     private translate: TranslateService,
  ) {
    this.customerSubscription = this.customerService.selectedCustomer$.subscribe(() => {
      if (this.router.url.includes('/home/index')) {
        this.getCurrency();
        this.getDashboardData();
      }
    });
   }
    cbfTranslateData: any[] = [];
    currencyName: string = "";
    actualTurnover: number = 0;
    inWarehouseProcessing: number = 0;
    opened: number = 0;
    creditBlock: number = 0;

    currentCbfType: string = "";
    cbfDetailMap: any = null;
    cbfTypeOption: string[] = [];

    achievementDetailCardData: any[] = []
    // current year and month
    monthArr: string[] = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    month = new Date().getMonth();
    yearString: any = new Date().getFullYear();
    get monthString(): string {
      return this.translate.instant(this.monthArr[this.month]);
    }
    get languageIsEn(): boolean {
      let config: any = localStorage.getItem('template_config');
      let language = config ? JSON.parse(config)?.language : 'zh';
      return language === 'en';
    }
   
   // Init
    ngOnInit(): void {
      this.getDashboardData()
      this.getCbfTranslateList()
    }

    // Destroy
    ngOnDestroy(): void {
      if (this.customerSubscription) {
        this.customerSubscription.unsubscribe();
      }
    }

    // change
    ngOnChanges(changes: SimpleChanges): void {
      
    }

    getCurrency(){
      this.loginService.getCurrency().subscribe(result => {
        const { data } = result;
        this.currencyName = data;
      })
    }

    getCbfTranslateList(){
      this.dealerPortalService.getDashboardCbfDictionary().subscribe(result => {
        const { rtnCode, rtnData } = result;
        this.cbfTranslateData = rtnData || []
      })
    }

    getCbfDescription(key: string){
      return this.languageIsEn ? key : this.translateToCbfCn(key)
    }
    translateToCbfEn(key: string){
      if(key === '所有类型'){
        return 'All Type'
      }
      if(this.cbfTranslateData?.length > 0){
        const cbf = this.cbfTranslateData?.find(item=> item.cbfCn === key)
        return cbf ? cbf.cbfDescription: ''
      }
      return ''
    }
    translateToCbfCn(key: string){
      if(key === 'All Type'){
        return '所有类型'
      }
      if(this.cbfTranslateData?.length > 0){
        const cbf = this.cbfTranslateData?.find(item=> item.cbfDescription === key)
        return cbf ? cbf.cbfCn: ''
      }
      return ''
    }
    // get dashboard module data
    getDashboardData(): void {
      this.dealerPortalService.getDashboardTarget().subscribe(result => {
        
        const { rtnCode, rtnData } = result;
        if (rtnCode === 10000) {
          const data = { ...rtnData }
          this.actualTurnover = data.actualTurnover || 0;
          this.inWarehouseProcessing = data.inWarehouseProcessing || 0;
          this.opened = data.opened || 0;
          this.creditBlock = data.creditBlock || 0;
          this.cbfDetailMap = data.cbfDetailMap || {};
          this.cbfTypeOption = Object.keys(data.cbfDetailMap);
          this.currentCbfType = this.languageIsEn ? 'All Type' : '所有类型';
          this.handleChangeProductType(this.currentCbfType)
        } 
      });
    }
    // 格式化数字
    formatNumber(number: number | string ): void {
      return formatThousandth(number || 0)
    }
    formatPercentage(number: number | null ): string {
      if(number === null){
        return '-'
      }
      return (Math.round(number * 100 * 100) / 100).toFixed(2) +'%';
    }

    // 选择CBF类型
    handleChangeProductType(e: string): void {
      const key = this.languageIsEn ? e : this.translateToCbfEn(e)
      this.achievementDetailCardData = this.cbfDetailMap[key].cbfAchievementList
      this.renderAchievementTurnoverBar(key)
      this.renderAchievementYTDChart(key)
    }

    responsiveSize = (size: number) => {
      const currentFontSize = parseInt(document.documentElement.style.fontSize);
      return size * (currentFontSize / 16);
    };

    // render Achievement Turnover Bar
    renderAchievementTurnoverBar(type: string): void {
      const xAxis: string[] = [];
      const actualTurnover: number[] = [];
      const sactualTurnoverLastYear: number[] = [];
      const data = this.cbfDetailMap[type].monthlyAchievement
      const pageWidth = document.body.clientWidth;
      data.forEach((item: any)=>{
        xAxis.push(this.translate.instant(this.monthArr[item.serialNo - 1]));
        actualTurnover.push(item.actualTurnover)
        sactualTurnoverLastYear.push(item.actualTurnoverLastYear)
      })
      const dom = document.getElementById('achievementChart')
      if(!dom) return
      var myChart = echarts.init(dom);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          position: pageWidth < 1000 ? ['50', '0']: false,
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: (params: any) => {
            const titleStyle = "color:#1F1F1F;font-weight:600;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
            const itemStyle = "color:#71767C;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
            const spanStyle = "color:#142743;margin-left:30px;font-weight:600;"
            const rectStyle = "width:12px;height:12px;display:inline-block;margin-right:5px;"
            const actual = data[params[0].dataIndex]['actualTurnover']
            const actualLast = data[params[0].dataIndex]['actualTurnoverLastYear']
            return `<div style="font-size: 13px;">
              <div style=${titleStyle}>${params[0].axisValueLabel}</div>
               <div style=${titleStyle}>
                ${this.translate.instant('ACTUAL')}. ${this.yearString} vs. ${this.translate.instant('ACTUAL')}. ${this.yearString-1} %
                <span style=${spanStyle}>${(actualLast === 0 ? 0 :(actual / actualLast)*100)?.toFixed(2)}%</span>
              </div>
              <div style=${itemStyle}>
                <div>
                  <span style=${rectStyle + 'background:#007BC0'}></span>
                  ${this.translate.instant('ACTUAL_TURNOVER')} (${this.yearString})
                </div>
                <span style=${spanStyle}>${formatThousandth(actual)}</span>
              </div>
              <div style=${itemStyle}>
                <div>
                  <span style=${rectStyle + 'background:#8DD2CD'}></span>
                  ${this.translate.instant('ACTUAL_TURNOVER')} (${this.yearString - 1})
                </div>
                <span style=${spanStyle}>${formatThousandth(actualLast)}</span>
              </div>
            </div>`
          },
        },
        legend: {
          bottom: 0,
          icon: 'rect',
          selectedMode: false
        },
        grid: {
          left: '3%',
          right: '4%',
          top: '4%',
          bottom: '13%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            data: xAxis,
            axisTick: {
              show: false
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            step: 5000,
            axisLabel: {
              // 使用 formatter 函数格式化标签文本
                formatter: function(value: any) {
                    return `${(value/1000)} K`; // 将数值保留两位小数并添加美元符号
                }
            }
          }
        ],
        series: [
          {
            name: `${this.translate.instant('ACTUAL_TURNOVER')} (${this.yearString})`,
            type: 'bar',
            barWidth: this.responsiveSize(20),
            stack: '2024',
            emphasis: {
              focus: 'series'
            },
            itemStyle: {
              color: "#007BC0"
            },
            data: actualTurnover
          },
          {
            name: `${this.translate.instant('ACTUAL_TURNOVER')} (${this.yearString -1})`,
            type: 'bar',
            barWidth: this.responsiveSize(20),
            itemStyle: {
              color: "#8DD2CD"
            },
            data: sactualTurnoverLastYear
          },
        ]
      });
      // add resize 
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    }

    // render Achievement YTD Bar
  renderAchievementYTDChart(type: string): void {
  
    const xAxis: string[] = [];
    const actualTurnoverTrend: number[] = [];
    const data = this.cbfDetailMap[type].monthlyAchievement
    data.forEach((item: any)=>{
      xAxis.push(this.translate.instant(this.monthArr[item.serialNo - 1]));
      actualTurnoverTrend.push(item.actualTurnoverTrend)
    })
    const dom = document.getElementById('YTDTrendsChart')
    if(!dom) return
    var myChart = echarts.init(dom);
  
    // 绘制图表
    myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        formatter: (params: any) => {
          const titleStyle = "color:#1F1F1F;font-weight:600;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
          const itemStyle = "color:#71767C;margin-bottom:4px;display:flex;justify-content:space-between;align-items:center;"
          const spanStyle = "color:#142743;margin-left:30px;font-weight:600;"
          const rectStyle = "width:12px;height:12px;display:inline-block;margin-right:5px;"
          return `<div style="font-size: 13px;">
            <div style=${titleStyle}>${params[0].axisValueLabel}</div>
            <div style=${itemStyle}>
              <div>
                <span style=${rectStyle + 'background:#007BC0'}></span>
                YTD Actual Turnover
              </div>
              <span style=${spanStyle}>${formatThousandth(params[0]?.value)}</span>
            </div>
            <div style=${itemStyle}>
              <div>
                <span style=${rectStyle + 'background:#9E2896'}></span>
                YTD Target Turnover
              </div>
              <span style=${spanStyle}>${formatThousandth(params[1]?.value)}</span>
            </div>
          </div>`
        },
      },
      xAxis: {
        type: 'category',
        data: xAxis
      },
      yAxis: {
        type: 'value',
        step: 5000,
        axisLabel: {
          // 使用 formatter 函数格式化标签文本
            formatter: function(value: any) {
                return `${(value/1000)} K`; // 将数值保留两位小数并添加美元符号
            }
        }
      },
      legend: {
        bottom: 0,
        icon: 'rect',
        selectedMode: false
      },
      grid: {
        left: '3%',
        right: '4%',
        top: '4%',
        bottom: '13%',
        containLabel: true
      },
      series: [
        {
          name: "YTD Actual Turnover Trend",
          data: actualTurnoverTrend,
          type: 'bar',
          barWidth: 17,
          itemStyle: {
            color: "#007BC0"
          },
        },
      ]
    });
  }


    // 跳转订单页
    goOrder(type:string):void{
      const country = localStorage.getItem("country");
      if(type=='warehouse'){
        localStorage.removeItem('isOrderDetailBack');
        this.router.navigate([`${country}/order/history`], { queryParams: { tabSelectNumber: 2 } });
      }else if(type=='open'){
        localStorage.removeItem('isOrderDetailBack');
        this.router.navigate([`${country}/order/history`], { queryParams: { tabSelectNumber: 1 } });
      }else if(type=='creditBlock'){
        localStorage.removeItem('isOrderDetailBack');
        this.router.navigate([`${country}/order/history`], { queryParams: { tabSelectNumber: 2,status:'Credit blocked' } });
      }
    }


}